import { TextFieldProps } from '@mui/material'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { Field, FieldProps } from 'formik'

type IProps = {
  name: string // formik field name
  label: string
  required: boolean
  disabled?: boolean
  fullWidth?: boolean
} & TextFieldProps

const FormikDatepicker = (props: IProps) => {
  const { name, label, required, fullWidth, disabled } = props

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Field name={name}>
        {({ field, form }: FieldProps) => (
          <DesktopDatePicker
            label={label}
            format="MM/dd/yyyy"
            disabled={disabled}
            value={field.value}
            onChange={(newValue: Date | null) => {
              form.setFieldValue(name, newValue, true)
            }}
            slotProps={{
              textField: {
                fullWidth,
                margin: 'normal',
                required,
              },
            }}
          />
        )}
      </Field>
    </LocalizationProvider>
  )
}

export default FormikDatepicker
